export default {
  'css': `app .loader,[is="app"] .loader{ border-top-color: #3498db; -webkit-animation: spinner 1.5s linear infinite; animation: spinner 1.5s linear infinite; } @-webkit-keyframes spinner { 0% { -webkit-transform: rotate(0deg); } 100% { -webkit-transform: rotate(360deg); } } @keyframes spinner { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`,
  'exports': null,

  'template': function(template, expressionTypes, bindingTypes, getComponent) {
    return template(
      '<div class="w-full h-full top-0 left-0 bg-white opacity-75 z-50"><span class="text-green-500 opacity-75 top-1/2 my-0 mx-auto block relative w-0 h-0" style="\n    top: calc(50% - 1em);\n"><div class="my-auto mx-auto"><h6 style="\n    position: absolute;\n    left: 1em;\n    top: 2.2em;\n">Loading...</h6><div class="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-24 w-24"></div></div></span></div>',
      []
    );
  },

  'name': 'app'
};